import React from 'react'

export const ModalContext = React.createContext({
  showModal: (_modalDetails) => undefined,
  hideModal: () => undefined,
  modal: undefined
});

export const ModalContextConsumer = ModalContext.Consumer;
